query AssistantUsagesList(
  $page: Int
  $rowsPerPage: Int
  $filter: AssistantUsagesFilterInput
) {
  assistantUsages(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      audience
      month
      costUsd
      messages
      budgetUsd
      platform {
        id
        title
      }
      organization {
        id
        title
      }
    }
  }
}
